import { BlurbCard } from 'ui/components';

export const BlurbCardFeature: React.FC<Content.BlurbCard> = ({ content, settings }) => (
	<BlurbCard {...content?.properties} />
);
